// Creates a definition for the Image component to be used in Contentful Studio
import {ComponentDefinition} from '@contentful/experiences-sdk-react';

import {
  imageSrcDefinition,
  imageAltTextDefinition,
  imageHasRoundedCornersDefinition,
} from '@/components/common/definitions';

export const ImageCorporateSiteContentfulComponentDefinition: ComponentDefinition =
  {
    id: 'image',
    name: 'Image',
    category: '03: Content Building Blocks',
    builtInStyles: ['cfWidth', 'cfHeight'],
    thumbnailUrl:
      'https://contentful-images.code.org/90t6bu6vlf76/2erlhdZVjByJbpMw9UKcWE/ee11e8a21370bbcd3b1b0b702b00d0e5/component_image_thumbnail.png',
    tooltip: {
      description: 'Add an image to your layout.',
      imageUrl:
        'https://contentful-images.code.org/90t6bu6vlf76/2Yl2LTZiEjpF9cTPzzC4TS/f6d57839806b1d310d1f527042c49e8b/component_image_tooltip.png',
    },
    variables: {
      ...imageSrcDefinition,
      ...imageAltTextDefinition,
      ...imageHasRoundedCornersDefinition,
      zIndex: {
        displayName: 'Z-index',
        type: 'Text',
        group: 'style',
        description:
          'Stacking order. Leave blank for default. Set an integer (e.g. 10 or -1) to layer above or below sibling elements.',
      },
    },
  };
